import { Table as BootstrapTable } from 'reactstrap';
import classNames from 'classnames';

export default function Table({ className = '', isData = true, isClickable = true, isVerticalMiddle, children, ...rest }) {
    return (
        <BootstrapTable {...rest} className={classNames(className, { 'table-data': isData, 'table-clickable': isClickable, 'table-vertical-middle': isVerticalMiddle })}>
            {children}
        </BootstrapTable>
    );
}
